import { __assign } from "tslib";
import React from 'react';
import TierThumbHtmlView from './TierHtml';
import TierThumbReactView from './Tier';
var TierThumbView = function (props) {
    if (props.isHtml) {
        return React.createElement(TierThumbHtmlView, __assign({}, props));
    }
    return React.createElement(TierThumbReactView, __assign({}, props));
};
TierThumbView.displayName = 'TierThumbView';
export default TierThumbView;
//# sourceMappingURL=index.js.map